import { isPublicId } from '@idc-forms/id'

/**
 * Con qué id se DIRECCIONA el expediente de un cliente desde fuera de su ola.
 *
 * El expediente ya se abre con el `cli_` —es el único id que entienden los
 * endpoints v2 de clientes—, pero las pantallas que enlazan hacia él desde
 * negociaciones y desde el dashboard siguen leyendo respuestas v1, que reciben
 * el `publicId` recién desde esta tajada.
 *
 * Mientras viva el PUENTE DE ID de la API (`clients/domain/client-id.ts`), v1
 * resuelve las dos formas, así que caer al `_id` mantiene el enlace vivo en vez
 * de navegar hacia `undefined` si un expediente todavía no tiene su `cli_`.
 *
 * CUÁNDO SE BORRA: junto con el puente. Ahí el `publicId` pasa a ser obligatorio
 * en los modelos y el typecheck señala a cada llamador que quede sin migrar.
 */
export function clientRouteId(client: { publicId?: string | null; _id: string }): string {
  return client.publicId ?? client._id
}

/**
 * El id del expediente que está CARGADO en los stores, sea quien sea que lo
 * haya cargado.
 *
 * El FEIC se monta desde dos lados mientras dura la convivencia: el expediente
 * v2 (`ClientDossierOriginal`, cuyo `id` es el `cli_`) y el documento legacy de
 * v1 (que trae `_id` de Mongo y un `id` uuid interno que no direcciona nada).
 * Por eso el `_id` gana cuando está: su presencia es la señal de que quien cargó
 * fue el legacy.
 *
 * Muere con la carga legacy: ahí el expediente siempre tiene `id` y es el `cli_`.
 */
export function loadedClientRouteId(original: { _id?: string; id?: string }): string | undefined {
  return original._id ?? original.id
}

/**
 * ¿El expediente que está cargado en los stores vino de la API v2?
 *
 * Lo dice el expediente mismo, no la URL: la vista lo carga por v2 y la edición
 * todavía por v1, así que dos pantallas con el MISMO `cli_` en la barra de
 * direcciones tienen adentro documentos distintos. Preguntarle a la URL hacía
 * que la ficha de edición ofreciera catálogos con ids públicos sobre datos
 * llenos de ObjectIds, y los selectores aparecían vacíos.
 *
 * Un expediente sin cargar —el alta— no vino de ningún lado: es `false`, y la
 * pantalla usa los catálogos de v1, que es por donde se va a guardar.
 */
export function loadedFromV2(original: { _id?: string; id?: string }): boolean {
  if (original._id) return false
  return isPublicId(original.id ?? '', 'cli')
}
